<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span>The California Days of Ralph Waldo Emerson</h1>
<p class="bkau">Brian C. Wilson</p>
<p class="bkpub">University of Massachusetts Press</p>
<p class="bkpub1">Amherst and Boston</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-WILSON-California-0003.vue?721d2f02